import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageContext';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import ServicesPage2 from '@/pages/ServicesPage2';
import RealEstatePage from '@/pages/RealEstatePage';
import QuantitativePage from '@/pages/QuantitativePage';
import AllServicesPage from '@/pages/AllServicesPage';
import QuantitativeResultsPage from '@/pages/QuantitativeResultsPage';
import AdminResultsDashboard from '@/pages/AdminResultsDashboard';
import AdminLoginPage from '@/pages/AdminLoginPage';
import EducationPage from '@/pages/EducationPage';
import P2PEducationPage from '@/pages/P2PEducationPage';
import AboutPage from '@/pages/AboutPage';
import InvestPage from '@/pages/InvestPage';
import LinksPage from '@/pages/LinksPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<AllServicesPage />} />
            <Route path="/services2" element={<ServicesPage2 />} />
            <Route path="/all-services" element={<AllServicesPage />} />
            <Route path="/real-estate" element={<RealEstatePage />} />
            <Route path="/realestate" element={<RealEstatePage />} />
            <Route path="/quantitative" element={<QuantitativePage />} />
            <Route path="/quantitative/results" element={<QuantitativeResultsPage />} />
            <Route path="/quantitative/results/login" element={<AdminLoginPage />} />
            <Route path="/quantitative/results/admin" element={<AdminResultsDashboard />} />
            <Route path="/education" element={<EducationPage />} />
            <Route path="/education/p2p" element={<P2PEducationPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/invest" element={<InvestPage />} />
            <Route path="/links" element={<LinksPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;